<header>
    <div class="container-fluid">
        <div class="row">
            <div class="col-6 col-sm-1">
                <ng-container *ngIf="getCurrentRoute!=='reports' && getCurrentRoute!=='sid' && getCurrentRoute !=='margin-calcuator' && getCurrentRoute !=='grid-data'">
                    <div class="heading">D<span>M</span>A</div>
                </ng-container>
                <ng-container *ngIf="getCurrentRoute==='reports'">
                    <div class="heading divider-line">D<span>M</span>A Reports</div> 
                </ng-container>
                <ng-container *ngIf="getCurrentRoute==='sid'">
                    <div class="heading logo"><img src="./assets/imgs/logo.png" class="img-fluid">  </div> 
                </ng-container>
                <ng-container *ngIf="getCurrentRoute==='margin-calcuator'">
                    <div class="heading margin"><div class="heading logo"><img src="./assets/imgs/logo.png" class="img-fluid">&nbsp;&nbsp;&nbsp;  Margin Calculator</div> </div> 
                </ng-container>
                <ng-container *ngIf="getCurrentRoute==='grid-data'">
                    <div class="heading margin"><div class="heading logo"><img src="./assets/imgs/logo.png" class="img-fluid">&nbsp;&nbsp;&nbsp;  Margin Calculator</div> </div> 
                </ng-container>
            </div>

            <div class="col-6 col-sm-8 custom-select-holder" [hidden]="getCurrentRoute!=='reports'">
                <app-dropdown class="inline-block" [list]="reportsItem" [showSearch]="false" [isPopover]="true" [isSingleSelect]="true"
                    (itemChange)="navigateReports($event)"></app-dropdown>
                <i class="fa fa-info-circle color inline-block" [title]="getReportDescription" aria-hidden="true"></i>
            </div>

            <div class="col-6 col-sm-8" [hidden]="getCurrentRoute==='reports'">
                <!-- <ng-container *ngIf="getCurrentRoute==='sid'">
                    <div class="heading sidheading"> 
                        Salesforce Interface for Delivery (SID)</div> 
                </ng-container> -->
            </div>

            <div class="col-6 col-sm-3">

                <div class="row">
                    <div class="col-6 p-0">
                        <!-- <a  role="button" href="#" click="onHelpClick()">May I help you</a> -->
                        <a *ngIf="getCurrentRoute!='help' && getCurrentRoute!='sid'" href="#" class="menu-user surveyLink" data-toggle="button" role="button" (click)="onHelpClick()">
                            May I Help you<i class="fa-regular fa-message"></i>
                        </a>
                    </div>
                    <div class="col-6" >
                        <div class="menu-user">
                            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                {{store.profile?.EmployeeName || ''}}
                                <img [src]="store.photo || './assets/imgs/user.png'" class="img-fluid">
                            </a>  

                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>{{store.profile?.EmployeeMail || ''}}</li>
                                <li [hidden]="!rolesWithSavingsGuideAccess.includes(store.profile?.EmpRole)" (click)="getSavingsGuide()">DMA Savings Guide</li>
                                <li (click)="getUserGuide()">DMA User Guide</li>
                                <li (click)="logout()">Logout</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</header>